import { Table } from '@tiptap/extension-table';

export const CustomTable = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      borderColor: {
        default: '#ccc',
        parseHTML: (element) => element.getAttribute('data-border-color') || '#ccc',
        renderHTML: ({ borderColor }) => {
          return {
            'data-border-color': borderColor,
            style: `border: 1px solid ${borderColor}; border-collapse: collapse; width: 100%;`,
          };
        },
      },
    };
  },

  addNodeView() {
    return ({ node }) => {
      const table = document.createElement('table');
      const contentDOM = document.createElement('tbody');
      table.appendChild(contentDOM);

      const updateAttrs = (attrs = {}) => {
        const borderColor = attrs.borderColor || '#ccc';
        table.setAttribute('data-border-color', borderColor);
        table.style.border = `1px solid ${borderColor}`;
        table.style.borderCollapse = 'collapse';
        table.style.width = '100%';
      };

      updateAttrs(node.attrs);

      return {
        dom: table,
        contentDOM,
        update(updatedNode) {
          updateAttrs(updatedNode.attrs);
          return true;
        },
      };
    };
  },
});
